// extracted by mini-css-extract-plugin
module.exports = {"settings":"Settings_settings__1dyRl","closeButton":"Settings_closeButton__3aHra","setDefaultsButton":"Settings_setDefaultsButton__bH40M"};